import PrivateRoute from 'components/PrivateRoute';
import FWAircraftDetailsPage from 'pages/window/flytwatch/aircraft-details-page';
import React from 'react';

export function getWindowRoutes() {
    return [
        <PrivateRoute exact path='/app/window/flytwatch/details/:id' render={({ match: { params: { id } } }) => <FWAircraftDetailsPage dispatchID={id} />} />,
    ]
}